import React, { useEffect, useState } from "react";
import styled from "styled-components";
import { useNavigate, useParams } from "react-router";
import { useSelector, useDispatch } from "react-redux";
import postQrInitManualTransaction from "../redux/actions/postQrInitManual";
import * as Yup from "yup";
import { bankNames, toLocaleStringFormate } from "../helpingFunctions";
import { language } from "../utils/language";
import ThaiQrLogo from "../assets/thaiQr.png";
import WalletTrue from "../assets/walletTrue.png";
import Prompt from "../assets/prompt.png";
import { Divider, Radio, Space } from "antd";
import ButtonWrapper from "./ButtonWrapper";
import AnimatedBtnWrapper from "./AnimatedBtnWrapper";
import { Fade, Reveal, Slide } from "react-awesome-reveal";
import getVerifyManualTransaction from "../redux/actions/getVerifyManualTransaction";
import WarningModal from "./WarningModal";
import LanugageSelector from "./LanugageSelector";
import SpinerIndicatorWhiteBg from "./SpinerIndicatorWhiteBg";

const CardWrapper = styled.div`
  height: auto;
  z-index: 999;
  @media (min-width: 280px) and (max-width: 768px) {
    width: 90%;
  }
  width: 30%;
  background: #fff;
  // padding: 20px 10px;
  display: flex;
  align-items: center;
  flex-direction: column;
  border-radius: 10px;
  .card-header {
    background: #162056;
    padding: 20px;
    border-top-left-radius: 10px;
    border-top-right-radius: 10px;
  }
  h3 {
    color: white;
  }
`;

const PaymentMethodSelectCard = (props) => {
  const params = useParams();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [value, setValue] = useState("");

  const { data, error } = useSelector(
    (state) => state.getVerifyManualTransactionReducer
  );
  const { isLoading } = useSelector((state) => state.postQrInitManualReducer);
  const { lang } = useSelector((state) => state.languageSelectorReducer);

  const currentURL = window.location.href; // returns the absolute URL of a page
  const getRedictionalUrl = currentURL.split("=")[1];

  const url = new URL(currentURL);
  const redirectionUrl = url.search?.split("Url=")[1];
  
  useEffect(() =>{
    if(data){
      if (redirectionUrl !== undefined) {
        localStorage.setItem("redirectionUrl", redirectionUrl);
      }else{
        localStorage.setItem("redirectionUrl", data?.redirectUrl || data?.siteUrl);
      }
    }
  }, [data])

  // const index = currentURL.indexOf("?");
  // let queryParams = "";

  // if (index !== -1) {
  //   const baseUrl = currentURL.substring(0, index);
  //   queryParams = currentURL.substring(index + 1);

  //   console.log("Base URL:", baseUrl);
  //   console.log("Query Parameters:", queryParams);
  // } else {
  //   console.log("Invalid URL format");
  // }

  useEffect(() => {
    dispatch({
      type: "GET_REDICTIONAL_URL",
      payLoad: redirectionUrl,
    });
  }, []);

  useEffect(() => {
    if (data) {
      let truemoneyParams = {
        qrCodeTransactionId: data.trxRef,
        type: "truemoney",
        amount: parseFloat(data?.amount),
        sessionId: data.sessionToken,
        userId: data.merchantId,
        bankCode: "022",
        bankName: "True Money Co. Ltd.(CIMB)",
        accountNumber: "",
      };

      let thaiqrParam = {
        qrCodeTransactionId: data.trxRef,
        amount: parseFloat(data.amount),
        userId: data.merchantId,
        type: "bypass",
        sessionId: data.sessionToken,
        bankCode: "",
        bankName: "",
        accountNumber: "",
      };

      // if select method have
      if(!data?.isBgActive){
        navigate(`/${params.id}/onepay-payment-method`);
      } else if (data?.selectedMethod) {
        // redirect to truemoney qr generated screen
        if (data?.selectedMethod == "truemoney" && data?.apiType !== "auto") {
          dispatch(
            postQrInitManualTransaction(truemoneyParams, navigate, params.id)
          );
          // redirect to thai qr generated screen
        } else if (
          data?.selectedMethod == "thaiqr" &&
          data?.apiType !== "auto"
        ) {
          dispatch(
            postQrInitManualTransaction(thaiqrParam, navigate, params.id)
          );
          // redirect to truemoney kyc form
        } else if (
          data?.selectedMethod == "truemoney" &&
          data?.apiType == "auto" &&
          data?.kycAvailable
        ) {
          dispatch(
            postQrInitManualTransaction(truemoneyParams, navigate, params.id)
          );
        } else if (
          data?.selectedMethod == "thaiqr" &&
          data?.apiType == "auto" &&
          data?.kycAvailable
        ) {
          dispatch(
            postQrInitManualTransaction(
              { ...thaiqrParam, type: "auto" },
              navigate,
              params.id
            )
          );
        } else if (
          data?.selectedMethod == "truemoney" &&
          data?.apiType == "auto" &&
          !data?.kycAvailable
        ) {
          navigate(`/${params.id}/truemoney-payment-method`);
          // redirect to thai qr kyc form
        } else if (
          data?.selectedMethod == "thaiqr" &&
          data?.apiType == "auto" &&
          !data?.kycAvailable
        ) {
          navigate(`/${params.id}/auto-payment-method`);
        }
      } else {
        if (!data.payOptions?.includes("truemoney")) {
          if (data.apiType == "bypass") {
            let qrManualTransactionParams = {
              qrCodeTransactionId: data.trxRef,
              amount: parseFloat(data.amount),
              userId: data.merchantId,
              type: "bypass",
              sessionId: data.sessionToken,
              bankCode: "",
              bankName: "",
              accountNumber: "",
            };
            dispatch(
              postQrInitManualTransaction(
                qrManualTransactionParams,
                navigate,
                params.id
              )
            );
          } else {
            // navigate(`/${params.id}/auto-payment-method`);
            dispatch(postQrInitManualTransaction(
              { ...thaiqrParam, type: "auto" },
              navigate,
              params.id
            ))
          }
        } else if (
          data.payOptions?.includes("truemoney") &&
          !data.payOptions?.includes("auto") &&
          data?.apiType == "auto" &&
          data?.kycAvailable
        ) {
          dispatch(
            postQrInitManualTransaction(truemoneyParams, navigate, params.id)
          );
        } else if (
          data.payOptions?.includes("truemoney") &&
          data.apiType == "auto" &&
          !data.payOptions?.includes("auto") &&
          !data.payOptions?.includes("bypass")
        ) {
          navigate(`/${params.id}/truemoney-payment-method`);
        } else if (
          data.payOptions?.includes("truemoney") &&
          data.apiType == "bypass" &&
          !data.payOptions?.includes("auto") &&
          !data.payOptions?.includes("bypass")
        ) {
          let qrManualTransactionParams = {
            qrCodeTransactionId: data.trxRef,
            type: "truemoney",
            amount: parseFloat(data?.amount),
            sessionId: data.sessionToken,
            userId: data.merchantId,
            bankCode: "022",
            bankName: "True Money Co. Ltd.(CIMB)",
            accountNumber: "",
          };
          dispatch(
            postQrInitManualTransaction(
              qrManualTransactionParams,
              navigate,
              params.id
            )
          );
        }
      }
    }
  }, [data]);

  return (
    <CardWrapper className="">
      <div className="card-header w-100">
        <h3 className="text-center">{language[lang].trnxInfoCard.PTI}</h3>
      </div>
      {!isLoading && !data.hasOwnProperty("selectedMethod") &&
        data.payOptions?.includes("truemoney") &&
        (data.payOptions?.includes("auto") ||
          data.payOptions?.includes("bypass")) ? (
        <div className="w-100 px-4 pb-4">
          <div className="mt-3 d-flex align-items-start justify-content-between">
            <p className=" w-75 text-center mr-2" style={{ lineHeight: 1 }}>
              {language[lang].trnxInfoCard.CARD_DESCRIPTION}
            </p>
            <LanugageSelector />
          </div>
          <Radio.Group
            className="mt-4"
            onChange={(e) => setValue(e.target.value)}
            value={value}
          >
            <Space direction="vertical">
              {data.payOptions?.includes("auto") ||
                data.payOptions?.includes("bypass") ? (
                <Radio
                  value={data.payOptions?.includes("auto") ? "auto" : "bypass"}
                  className=""
                >
                  <img src={ThaiQrLogo} width={"100px"} />
                  <img src={Prompt} style={{ minWidth: 50, height: 50 }} />
                  {/* <img src={WalletTrue} height="70px" /> */}
                </Radio>
              ) : null}
              {data.payOptions?.includes("truemoney") ? (
                <Radio
                  value={data.payOptions?.includes("truemoney") && "truemoney"}
                >
                  {/* <img src={ThaiQrLogo} width={"100px"} />
                <img src={Prompt} style={{ minWidth: 50, height: 50 }} /> */}
                  <img src={WalletTrue} height="70px" />
                </Radio>
              ) : null}
            </Space>
          </Radio.Group>
          <div className="d-flex mt-5">
            <p className="label fw-bold mb-0">
              {language[props.lang].trnxInfoCard.AMOUNT}(฿)*
            </p>
            <p className="label fw-bold mb-0 ms-5">
              {toLocaleStringFormate(data?.amount)}
            </p>
          </div>
          {/* <AnimatedBtnWrapper  text={"ต่อไป"} onClick={() => navigate(`/${value}`)} /> */}
          <ButtonWrapper
            onClick={() => {
              if (value === "bypass" || value === "auto") {
                let qrManualTransactionParams = {
                  qrCodeTransactionId: data.trxRef,
                  amount: parseFloat(data.amount),
                  userId: data.merchantId,
                  type: value,
                  sessionId: data.sessionToken,
                  bankCode: "",
                  bankName: "",
                  accountNumber: "",
                };
                dispatch(
                  postQrInitManualTransaction(
                    qrManualTransactionParams,
                    navigate,
                    params.id
                  )
                );
              }
              // else if (
              //   value == "truemoney" &&
              //   data.payOptions?.includes("auto") &&
              //   data.apiType == "auto"
              // ) {
              //   navigate(`/${params.id}/truemoney-payment-method`);
              // } 
              else if (
                value === "truemoney"
                // &&
                // !data.payOptions?.includes("auto")
              ) {
                let qrManualTransactionParams = {
                  qrCodeTransactionId: data.trxRef,
                  type: "truemoney",
                  amount: parseFloat(data?.amount),
                  sessionId: data.sessionToken,
                  userId: data.merchantId,
                  bankCode: "022",
                  bankName: "True Money Co. Ltd.(CIMB)",
                  accountNumber: "",
                };
                dispatch(
                  postQrInitManualTransaction(
                    qrManualTransactionParams,
                    navigate,
                    params.id
                  )
                );
              } else {
                navigate(`/${params.id}/${value}-payment-method`);
              }
            }}
            size="middle"
            height="40px"
            border={true}
            htmlType="submit"
            disabled={value ? false : true}
            loading={isLoading}
            className="w-100 mt-4 btn "
            text={language[lang].trnxInfoCard.NEXT_BTN_TEXT}
          />
        </div>
      ) : (
        <div>
          <SpinerIndicatorWhiteBg
            thaiText="โปรดรอสักครู่ เรากำลังนำคุณไปยังหน้าใหม่"
            fontSize="15px"
            color="#000"
          />
        </div>
      )}
    </CardWrapper>
  );
};

export default PaymentMethodSelectCard;
